; ( function ( $ ) {

	'use strict';

	const pluginName = 'liquidMap';
	let defaults = {
		address: '7420 Shore Rd, Brooklyn, NY 11209, USA',
		marker: null,
		style: 'wy',
		marker_style: 'default', // options: "image","html"
		className: 'lqd-custom-map-marker pos-abs absolute border-radius-circle',
		markers: null,
		map: {
			zoom: 16,
			mapTypeId: 'roadmap',
			disableDefaultUI: true,
			panControl: false,
			zoomControl: true,
			mapTypeControl: false,
			streetViewControl: false,
			scrollwheel: false
		}
	};

	const styles = {
		"wy": [ { "featureType": "all", "elementType": "geometry.fill", "stylers": [ { "weight": "2.00" } ] }, { "featureType": "all", "elementType": "geometry.stroke", "stylers": [ { "color": "#9c9c9c" } ] }, { "featureType": "all", "elementType": "labels.text", "stylers": [ { "visibility": "on" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [ { "color": "#eeeeee" } ] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [ { "color": "#7b7b7b" } ] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#46bcec" }, { "visibility": "on" } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#c8d7d4" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#070707" } ] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [ { "color": "#ffffff" } ] } ],
		"blueEssence": [ { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [ { "visibility": "on" }, { "color": "#e0efef" } ] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [ { "visibility": "on" }, { "hue": "#1900ff" }, { "color": "#c0e8e8" } ] }, { "featureType": "road", "elementType": "geometry", "stylers": [ { "lightness": 100 }, { "visibility": "simplified" } ] }, { "featureType": "road", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [ { "visibility": "on" }, { "lightness": 700 } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#7dcdcd" } ] } ],
		"lightMonochrome": [ { "featureType": "administrative.locality", "elementType": "all", "stylers": [ { "hue": "#2c2e33" }, { "saturation": 7 }, { "lightness": 19 }, { "visibility": "on" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "hue": "#ffffff" }, { "saturation": -100 }, { "lightness": 100 }, { "visibility": "simplified" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "hue": "#ffffff" }, { "saturation": -100 }, { "lightness": 100 }, { "visibility": "off" } ] }, { "featureType": "road", "elementType": "geometry", "stylers": [ { "hue": "#bbc0c4" }, { "saturation": -93 }, { "lightness": 31 }, { "visibility": "simplified" } ] }, { "featureType": "road", "elementType": "labels", "stylers": [ { "hue": "#bbc0c4" }, { "saturation": -93 }, { "lightness": 31 }, { "visibility": "on" } ] }, { "featureType": "road.arterial", "elementType": "labels", "stylers": [ { "hue": "#bbc0c4" }, { "saturation": -93 }, { "lightness": -2 }, { "visibility": "simplified" } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "hue": "#e9ebed" }, { "saturation": -90 }, { "lightness": -8 }, { "visibility": "simplified" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "hue": "#e9ebed" }, { "saturation": 10 }, { "lightness": 69 }, { "visibility": "on" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "hue": "#e9ebed" }, { "saturation": -78 }, { "lightness": 67 }, { "visibility": "simplified" } ] } ],
		"assassinsCreedIV": [ { "featureType": "all", "elementType": "all", "stylers": [ { "visibility": "on" } ] }, { "featureType": "all", "elementType": "labels", "stylers": [ { "visibility": "off" }, { "saturation": "-100" } ] }, { "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 }, { "visibility": "off" } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" }, { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [ { "color": "#4d6059" } ] }, { "featureType": "landscape", "elementType": "geometry.stroke", "stylers": [ { "color": "#4d6059" } ] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [ { "color": "#4d6059" } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "lightness": 21 } ] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [ { "color": "#4d6059" } ] }, { "featureType": "poi", "elementType": "geometry.stroke", "stylers": [ { "color": "#4d6059" } ] }, { "featureType": "road", "elementType": "geometry", "stylers": [ { "visibility": "on" }, { "color": "#7f8d89" } ] }, { "featureType": "road", "elementType": "geometry.fill", "stylers": [ { "color": "#7f8d89" } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#7f8d89" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#7f8d89" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 18 } ] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [ { "color": "#7f8d89" } ] }, { "featureType": "road.arterial", "elementType": "geometry.stroke", "stylers": [ { "color": "#7f8d89" } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [ { "color": "#7f8d89" } ] }, { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [ { "color": "#7f8d89" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 19 } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#2b3638" }, { "visibility": "on" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#2b3638" }, { "lightness": 17 } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#24282b" } ] }, { "featureType": "water", "elementType": "geometry.stroke", "stylers": [ { "color": "#24282b" } ] }, { "featureType": "water", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] } ],
		"unsaturatedBrowns": [ { "elementType": "geometry", "stylers": [ { "hue": "#ff4400" }, { "saturation": -68 }, { "lightness": -4 }, { "gamma": 0.72 } ] }, { "featureType": "road", "elementType": "labels.icon" }, { "featureType": "landscape.man_made", "elementType": "geometry", "stylers": [ { "hue": "#0077ff" }, { "gamma": 3.1 } ] }, { "featureType": "water", "stylers": [ { "hue": "#00ccff" }, { "gamma": 0.44 }, { "saturation": -33 } ] }, { "featureType": "poi.park", "stylers": [ { "hue": "#44ff00" }, { "saturation": -23 } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "hue": "#007fff" }, { "gamma": 0.77 }, { "saturation": 65 }, { "lightness": 99 } ] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [ { "gamma": 0.11 }, { "weight": 5.6 }, { "saturation": 99 }, { "hue": "#0091ff" }, { "lightness": -86 } ] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [ { "lightness": -48 }, { "hue": "#ff5e00" }, { "gamma": 1.2 }, { "saturation": -23 } ] }, { "featureType": "transit", "elementType": "labels.text.stroke", "stylers": [ { "saturation": -64 }, { "hue": "#ff9100" }, { "lightness": 16 }, { "gamma": 0.47 }, { "weight": 2.7 } ] } ],
		"classic": [ { "featureType": "administrative.country", "elementType": "geometry", "stylers": [ { "visibility": "simplified" }, { "hue": "#ff0000" } ] } ],
		"evenLighter": [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#6195a0" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [ { "color": "#e6f3d6" }, { "visibility": "on" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 }, { "visibility": "simplified" } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#f4d2c5" }, { "visibility": "simplified" } ] }, { "featureType": "road.highway", "elementType": "labels.text", "stylers": [ { "color": "#4e4e4e" } ] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [ { "color": "#f4f4f4" } ] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [ { "color": "#787878" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#eaf6f8" }, { "visibility": "on" } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#eaf6f8" } ] } ],
		"shadesOfGray": [ { "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 21 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#000000" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 19 } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 17 } ] } ]
	};
	class LqdGMap {


		constructor( element, options ) {

			this._defaults = defaults;
			this._name = pluginName;

			this.options = { ...defaults, ...options };
			this.options.map = { ...defaults.map, ...options.map };

			this.element = element;
			this.$element = $( element );

			this.init( element, this.options );

		}

		init() {

			this.build();
			this.adjustHeight();

			return this;
		}

		build() {

			const mapOpts = { ...this.options.map, styles: styles[ this.options.style ] };
			const map = new google.maps.Map( this.element, mapOpts );
			const geocoder = new google.maps.Geocoder();

			geocoder.geocode( {
				"address": this.options.address
			}, ( results, status ) => {

				if ( status == google.maps.GeocoderStatus.OK ) {

					const result = results[ 0 ].geometry.location;
					const latitude = results[ 0 ].geometry.location.lat();
					const longitude = results[ 0 ].geometry.location.lng();

					if ( this.options.marker_style === 'html' ) {

						this.$element.addClass( 'marker-html' );

					}

					if ( this.options.markers == null ) {

						this.addMarker( result, map );

					} else {

						for ( var i = 0; i < this.options.markers.length; i++ ) {

							this.addMarker( new google.maps.LatLng( this.options.markers[ i ][ 0 ], this.options.markers[ i ][ 1 ] ), map );

						}

					}

					//center map on location
					map.setCenter( new google.maps.LatLng( latitude, longitude ) );

					$( '.lightbox-link[data-type=inline]' ).on( 'mfpOpen', function ( e ) {
						setTimeout( function () {
							map.setCenter( new google.maps.LatLng( latitude, longitude ) );
						}, 500 );
					} );

					$( document ).on( 'shown.bs.tab', 'a[data-toggle="tab"]', function ( e ) {
						setTimeout( function () {
							map.setCenter( new google.maps.LatLng( latitude, longitude ) );
						}, 500 );
					} );

				}

			} );

			$( document ).on( 'shown.bs.tab', 'a[data-toggle="tab"]', function ( e ) {
				setTimeout( function () {
					google.maps.event.trigger( map, 'resize' );
				}, 500 );
			} );

			return this;
		}

		addMarker( pos, map ) {

			if ( this.options.marker_style === 'image' || this.options.marker_style === 'default' ) {

				new google.maps.Marker( {
					position: pos,
					map: map,
					visible: true,
					icon: this.options.marker,
					zIndex: 9999999
				} );

			} else if ( this.options.marker_style === 'html' ) {

				if ( typeof google !== typeof undefined && typeof google.maps !== typeof undefined ) {

					new LqdCustomMarker( pos, map, this.options.className );

				}

			}

		}

		adjustHeight() {

			const $parent = this.$element.parent( '.ld-gmap-container' );
			const $vcRowParent = $parent.parents( '.vc_row' ).last();

			if (
				!$parent.siblings().length &&
				$vcRowParent.hasClass( 'vc_row-o-equal-height' )
			) {
				$parent.height( $parent.parent().outerHeight() );
			}

		}

	};

	function LqdCustomMarker( latlng, map, className ) {
		this.latlng_ = latlng;
		this.className = className;
		this.setMap( map );
	}

	if ( typeof google !== typeof undefined && typeof google.maps !== typeof undefined ) {

		LqdCustomMarker.prototype = new google.maps.OverlayView();

		LqdCustomMarker.prototype.draw = function () {
			let div = this.div_;
			let divChild;
			let divChild2;

			if ( !div ) {
				div = this.div_ = document.createElement( 'DIV' );

				div.className = this.className;

				divChild = document.createElement( "div" );
				divChild.className = 'lqd-overlay border-radius-circle'
				div.appendChild( divChild );

				divChild2 = document.createElement( "div" );
				divChild2.className = 'lqd-overlay border-radius-circle'
				div.appendChild( divChild2 );

				google.maps.event.addDomListener( div, "click", () => {
					google.maps.event.trigger( this, "click" );
				} );

				const panes = this.getPanes();
				panes.overlayImage.appendChild( div );
			}

			const point = this.getProjection().fromLatLngToDivPixel( this.latlng_ );
			if ( point ) {
				div.style.left = point.x + 'px';
				div.style.top = point.y + 'px';
			}
		};

		LqdCustomMarker.prototype.remove = function () {
			if ( this.div_ ) {
				this.div_.parentNode.removeChild( this.div_ );
				this.div_ = null;
			}
		};

		LqdCustomMarker.prototype.getPosition = function () {
			return this.latlng_;
		};

	}

	$.fn[ pluginName ] = function ( options ) {

		return this.each( function () {

			const pluginOptions = $( this ).data( 'plugin-options' ) || options;

			if ( !$.data( this, "plugin_" + pluginName ) ) {

				$.data( this, "plugin_" + pluginName, new LqdGMap( this, pluginOptions ) );

			}

		} );

	};

}( jQuery ) );

$liquidWindow.on( 'load', () => {
	if ( typeof google !== typeof undefined && google !== null ) {
		jQuery( '[data-plugin-map]' ).liquidMap();
	}
} );
